import {UI} from "../../../stem-core/ui/UIBase";
import {Select} from "../../../stem-core/ui/input/Input.jsx";
import {Merchant} from "../../../client/state/MerchantStore.js";
import {getQueryParam} from "../../../blinkpay/UtilsLib.js";
import {Router} from "../../../stem-core/ui/Router.jsx";
import {BlinkInputField} from "../../../dashboard/common/Input.jsx";
import {EmailTemplateEditor} from "../../../dashboard/pages/emailing/EmailTemplateEditor.jsx";
import {
    apiCreateEmailTemplate,
    EmailTemplate,
    EmailTemplateType
} from "../../../client/state/EmailTemplateStore.js";
import {Button} from "../../../stem-core/ui/button/Button.jsx";


export class EmailTemplateCreator extends UI.Element {
    async createEmailTemplate() {
        const {merchant, emailTemplateType} = this.options;
        const request = {
            type: emailTemplateType,
            merchantId: merchant.id,
        }
        await apiCreateEmailTemplate(request);
        this.dispatch("createTemplate");
    }

    addCreateListener(listener) {
        return this.addListener("createTemplate", listener);
    }

    render() {
        return [
            <div>
                No email template is registered, the default one is being used.
            </div>,
            <Button onClick={() => this.createEmailTemplate()}>
                Create from default
            </Button>
        ]
    }
}


export class EmailTemplatesPage extends UI.Element {
    DEFAULT_TEMPLATE_TYPE = "successful_donation"; // TODO: use an enum
    DEFAULT_MERCHANT_ID = "default";

    changeUrl(templateType, merchantId) {
        Router.changeURL(`/email-templates/?templateType=${templateType}&merchantId=${merchantId}`,
            {forceElementUpdate:true});
        this.redraw();
    }

    render() {
        const emailTemplateType = getQueryParam("templateType") || this.DEFAULT_TEMPLATE_TYPE;
        const merchantId = getQueryParam("merchantId") || this.DEFAULT_MERCHANT_ID;
        const merchant = Merchant.get(merchantId);
        const merchantList = [this.DEFAULT_MERCHANT_ID, ...Merchant.all()];
        const emailTemplate = EmailTemplate.find(emailTemplate => {
            return emailTemplate.merchantId == merchantId && emailTemplate.type == emailTemplateType;
        })

        return [
            <div>
                <BlinkInputField label="Merchant">
                    <Select
                        selected={merchant || this.DEFAULT_MERCHANT_ID}
                        options={merchantList}
                        onChange={(selector) => {
                            const merchant = selector.getValue();
                            this.changeUrl(emailTemplateType, merchant.id || merchant); // Either we have a merchant or DEFAULT_MERCHANT_ID
                        }}/>

                </BlinkInputField>
                <BlinkInputField label="Email type">
                    <Select
                        options={EmailTemplateType.all()}
                        selected={emailTemplateType}
                        onChange={(selector) => this.changeUrl(selector.getValue(), merchantId)}
                    />
                </BlinkInputField>
            </div>,
            <hr/>,
            emailTemplate ? <EmailTemplateEditor
                emailTemplate={emailTemplate}
            /> : <EmailTemplateCreator
                emailTemplateType={emailTemplateType}
                merchant={merchant}
                onCreate={() => this.redraw()}
            />
        ]
    }
}
